import React, { useContext, useEffect } from "react";
import { Checkbox } from "best-common-react";
import { EditCustomCardContext } from "../contexts/EditCustomCardContext";

const GameDateAndTime = () => {
  const editCustomCardContext = useContext(EditCustomCardContext);
  const { dugoutCardInfo } = editCustomCardContext.state;
  const { dispatch } = editCustomCardContext;

  useEffect(() => {
    if (dugoutCardInfo.showGameDateText == null) {
      dispatch({
        type: "setDugoutGameDate",
        checked: false
      });
    }

    if (dugoutCardInfo.showGameTimeText == null) {
      dispatch({
        type: "setDugoutGameTime",
        checked: false
      });
    }
  }, []);

  return (
    <div className="col-lg-6 col-md-12 col-sm-12">
      <div className="d-flex">
        <div className="mr-4">
          <Checkbox
            label="Game Date"
            checked={dugoutCardInfo.showGameDateText}
            onChange={() => {
              dispatch({
                type: "setDugoutGameDate",
                checked: !dugoutCardInfo.showGameDateText
              });
            }}
          />
        </div>
        <Checkbox
          label="Game Time"
          checked={dugoutCardInfo.showGameTimeText}
          onChange={() => {
            dispatch({
              type: "setDugoutGameTime",
              checked: !dugoutCardInfo.showGameTimeText
            });
          }}
        />
      </div>
    </div>
  );
};

export default GameDateAndTime;
